import React, { Component } from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { MyContext, MyGlobal, MyHeading, MyAlert } from '../GlobalContext';
import ConfirmLocationChargeSkeleton from '../ConfirmLocationChargeSkeleton';
import LocationTransfer_AdditonalInfo from '../Transfers/LocationTransfer_AdditonalInfo';

export class LocationToLocation extends Component {
    static displayName = LocationToLocation.name;

    constructor(props) {
        super(props);
        this.state = {
            inventories: [],
            sending: false,
            headerTitle: "Location Transfer",
            alertMessage: "",
            fromLocationStatus: "",
            toLocationStatus: "",
            toLocation: "",
            fromLocation: "",
            fromLocationBarcode: "",
            toLocationBarcode: "",
            additional_info_toLocationBarcode: "",
            hasFromLocationLoaded: false,
            isTransferDisabled: false,
            displayConfirmChargePrompt: false,
            displayAdditionalInfo: false,
            chargesToBeConfirmed: [
                "STANDARD PALLET",
                "TWO PALLET",
                "THREE PALLET",
                "FOUR PALLET",
                "SIX PALLET",
                "EIGHT PALLET"],
            locationData: "",
            toLocationCharge: ""
        };
        this.history = props.history;

    }

    componentDidMount() {
        this.refs.transferFromLocationInput.focus();
        this.setState({
            chargesToBeConfirmed: [
                "STANDARD PALLET",
                "TWO PALLET",
                "THREE PALLET",
                "FOUR PALLET",
                "SIX PALLET",
                "EIGHT PALLET"]
        });
    }
    clearAll(message) {
        this.refs.transferFromLocationInput.focus();
        this.setState({
            alertMessage: message,
            inventories: [],
            fromLocationStatus: "",
            toLocationStatus: "",
            toLocation: "",
            fromLocation: "",
            fromLocationBarcode: "",
            toLocationBarcode: "",
            hasFromLocationLoaded: false,
            namecode: ""
        });

    }
    async loadStock() {

        if (this.state.fromLocationBarcode == "") {

            this.clearAll("Enter a valid Location barcode to load the Stock from");
            return;
        }

        this.state.fromLocationBarcode = this.state.fromLocationBarcode.trim();
        this.setState({ alertMessage: "" });
        var warehouseID = MyGlobal.warehouse;
        this.state.loading = true;

        fetch(`api/Transfer/GetStock?barcodeText=${this.state.fromLocationBarcode}&warehouseID=${warehouseID}`)
            .then(async response => {

                this.state.loading = false;
                // check for error response
                if (!response.ok) {
                    const errorText = await response.text();
                    this.clearAll("Cannot load Stock. " + errorText);
                }
                else {
                    const isJson = response.headers.get('content-type')?.includes('application/json');
                    const apiResponse = isJson ? await response.json() : null;

                    if (apiResponse) {
                        const data = apiResponse.data;
                        if (data && data.hasMultipleClients) {

                            this.setState({
                                inventories: data.inventoryList,
                                fromLocation: data.locationId,
                                fromLocationStatus: data.locationStatus,
                                hasFromLocationLoaded: true,
                                alertMessage: `Transfer prevented \r\n The location contains stock from another client. You will need to use Product Transfers for this location`,
                                isTransferDisabled: true
                            });
                            return;

                        }
                        if (data && data.inventoryList && data.inventoryList.length > 0) {
                            this.state.namecode = data.inventoryList[0].namecode;
                            this.setState({ inventories: data.inventoryList, fromLocation: data.locationId, fromLocationStatus: data.locationStatus, hasFromLocationLoaded: true });
                        }
                        else {
                            this.setState({ alertMessage: "This location does not contain inventory. Cannot start transfer here", hasFromLocationLoaded: false });
                        }
                        if (apiResponse.success) {
                            if (data.hasCommittedStock > 0) {
                                this.setState({ alertMessage: "Warning!! This location has committed stock.", isTransferDisabled: true });
                            }
                            else {
                                this.refs.transferToLocationInput.focus();
                            }
                        }
                        else {
                            this.setState({ alertMessage: apiResponse.errorMessage, isTransferDisabled: true });
                        }
                    }
                    else {
                        this.setState({ alertMessage: "Cannot load Stock!!" });
                    }
                }

            })
            .catch(error => {
                this.setState({ inventories: [], alertMessage: error });
            });
    }


    async transferInventories() {
        if (this.state.fromLocationBarcode == "" || this.state.fromLocation == "") {
            this.clearAll("Enter a valid Location barcode to load the Stock from. Click the Load Stock button");
            return;
        }

        if (this.state.toLocationBarcode == "") {
            this.setState({ alertMessage: "Enter a valid Location barcode to transfer the stock" });
            return;
        }
        this.state.toLocationBarcode = this.state.toLocationBarcode.trim();

        if (this.state.fromLocationBarcode == this.state.toLocationBarcode || this.state.fromLocation == this.state.toLocation) {
            this.setState({ alertMessage: "Cannot transfer stock to the same Location.", toLocationBarcode: "" });
            return;
        }


        this.setState({ alertMessage: "", additional_info_toLocationBarcode: this.state.toLocationBarcode });
        this.state.loading = true;
        const txStockRequestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                FromLocationId: this.state.fromLocation,
                FromLocationBarcode: this.state.fromLocationBarcode,
                ToLocationBarcode: this.state.toLocationBarcode,
                WarehouseId: MyGlobal.warehouse,
                UserName: MyGlobal.username,
                StaffName: MyGlobal.staffName,
                Namecode: this.state.namecode
            })
        };
        fetch('api/Transfer/TransferStock', txStockRequestOptions)
            .then(async response => {
                this.state.loading = false;

                // check for error response
                if (!response.ok) {
                    const errorText = await response.text();
                    this.setState({ alertMessage: "Transfer Failed!! " + errorText, toLocationBarcode: "" });
                }
                else {
                    const isJson = response.headers.get('content-type')?.includes('application/json');
                    const apiResponse = isJson ? await response.json() : null;

                    if (apiResponse) {
                        const data = apiResponse.data;
                        if (apiResponse.success) {
                            if (data.status === 2) {
                                this.setState({ alertMessage: "Transfer Failed!! " + data.responseText, toLocationBarcode: "" });
                            }
                            else {
                                if (this.state.toLocationBarcode && this.state.toLocationBarcode !== "") {

                                    await this.getLocationStatus(this.state.toLocationBarcode);

                                    const matchingChargeToBeConfirmed = this.state.chargesToBeConfirmed.find((element) => {
                                        return element === this.state.toLocationCharge;
                                    });
                                    if (matchingChargeToBeConfirmed) {
                                        var warehouseID = MyGlobal.warehouse;
                                        fetch(`api/Location/GetClientOption?namecode=${this.state.namecode}&warehouseId=${warehouseID}&option=90`)
                                            .then(async response => {
                                                this.setState({ loading: false });
                                                // check for error response
                                                if (!response.ok) {
                                                    const errorText = await response.text();
                                                    console.error(errorText);
                                                    this.setState({ alertMessage: "Transfer completed. But failed to display Charge Skeleton Update Prompt !!" });
                                                    return;
                                                }
                                                else {
                                                    const isJson = response.headers.get('content-type')?.includes('application/json');
                                                    const apiResponse = isJson ? await response.json() : null;
                                                    if (apiResponse) {

                                                        if (apiResponse.success) {
                                                            if (apiResponse.data.value == "Y") {
                                                                //Load prompt
                                                                this.setState({ displayConfirmChargePrompt: true });
                                                            }
                                                        }
                                                        else {
                                                            this.setState({ alertMessage: "Transfer completed. But failed to display Charge Skeleton Update Prompt !!" });
                                                        }
                                                    }
                                                    else {
                                                        this.setState({ alertMessage: "Transfer completed. But failed to display Charge Skeleton Update Prompt !!" });
                                                    }
                                                }
                                            })
                                            .catch(error => {
                                                this.setState({ alertMessage: error });
                                            });
                                    }                                    

                                }
                                this.clearAll(data.responseText);
                                this.state.additional_info_toLocationBarcode = "";
                            }
                        }
                        else {
                            this.setState({ alertMessage: apiResponse.errorMessage, toLocationBarcode: "" });
                        }
                    }
                    else {
                        this.setState({ alertMessage: "Transfer Failed!!" });
                    }

                }
            })
            .catch(error => {
                this.state.loading = false;
                this.setState({ inventories: [], alertMessage: error });
            });

    }

    prefixBarcodeSegmentWithZero(barCodeSegment) {
        if (barCodeSegment.length == 1) {
            barCodeSegment = "0" + barCodeSegment;
        }
        return barCodeSegment;
    }
    async getLocationStatus(locationBarcode) {
        var warehouseID = MyGlobal.warehouse;

        this.state.fromLocationBarcode = this.state.fromLocationBarcode.trim();
        var url = `api/Tote/GetLocationStatusByBarcode?warehouseID=${warehouseID}&barcode=${locationBarcode}`;
        const response = await fetch(url, {
        });
        const data = await response.json();

        if (data != null) {
            if (data.length > 0) {
                let charge = "";
                for (var value of data) {

                    charge = value.Charge;
                }
                this.state.locationData = data;
                this.state.toLocationCharge = charge;

            }
        }
    }
    confirmLocationCloseEvent() {

        this.setState({ displayConfirmChargePrompt: false });

    }
    confirmAdditionalInfoCloseEvent() {

        this.setState({ displayAdditionalInfo: false });

    }
    renderTable(data) {
        return (
            <table className='table table-striped' aria-labelledby="tabelLabel">
                <thead>
                    <tr>
                        <th>Code</th>
                        <th>Description</th>
                        <th>Grade1</th>
                        <th>Grade2</th>
                        <th>Grade3</th>
                        <th>PackingDate</th>
                        <th>ExpiryDate</th>
                        <th>Units</th>
                        <th>Commited</th>
                        <th>Client</th>
                    </tr>
                </thead>
                <tbody>
                    {data.map((row, index) =>
                        <tr key={index}>
                            <td>{row.productCode}</td>
                            <td>{row.productDescription}</td>
                            <td>{row.grade1}</td>
                            <td>{row.grade2}</td>
                            <td>{row.grade3}</td>
                            <td>{row.packingDate ? new Date(row.packingDate).toLocaleDateString() : ''}</td>
                            <td>{row.expiryDate ? new Date(row.expiryDate).toLocaleDateString() : ''}</td>
                            <td>{row.units}</td>
                            <td>{row.committedUnits}</td>
                            <td>{row.clientName}</td>
                        </tr>
                    )}
                </tbody>
            </table>
        );
    }
    render() {

        const handleFromLocationKeypress = e => {
            //it triggers by pressing the enter key
            if (e.keyCode === 13 || e.charCode === 13 || e.which === 13) {
                this.loadStock();
            }
        };
        const handleToLocationKeypress = e => {
            //it triggers by pressing the enter key
            if (e.keyCode === 13 || e.charCode === 13 || e.which === 13) {
                this.transferInventories();
            }
        };


        const alertMessage = this.state.alertMessage;

        const formatAlertMessage = message => {
            return message.split('\r\n').map((line, index) => (
                <React.Fragment key={index}>
                    {line.split('**').map((part, i) =>
                        i % 2 === 1 ? <strong key={i}>{part}</strong> : part
                    )}
                    <br />
                </React.Fragment>
            ));
        };
        let inventoryContents = this.renderTable(this.state.inventories);


        let displayPrompt = this.state.displayConfirmChargePrompt;
        displayPrompt = displayPrompt === true ? <ConfirmLocationChargeSkeleton show={this.state.displayConfirmChargePrompt} locationData={this.state.locationData} onClickClose={() => { this.confirmLocationCloseEvent(); }}  ></ConfirmLocationChargeSkeleton> : "";

        let displayAdditionalInfoPrompt = this.state.displayAdditionalInfo;
        displayAdditionalInfoPrompt = displayAdditionalInfoPrompt === true ? <LocationTransfer_AdditonalInfo show={this.state.displayAdditionalInfo} validationMessage={this.state.alertMessage} fromLocation={this.state.fromLocationBarcode} toLocation={this.state.additional_info_toLocationBarcode} onClickClose={() => { this.confirmAdditionalInfoCloseEvent(); }}  ></LocationTransfer_AdditonalInfo > : "";

        let loadingProgress = this.state.loading ? <Container><Row><Col><p><em>Loading...</em></p> </Col></Row></Container> : <p></p>;

        return (
            <div>
                {loadingProgress}
                <Container>
                    <Row>
                        <Col>
                            {alertMessage !== "" && (
                                <MyAlert variant="danger">
                                    {formatAlertMessage(alertMessage)}
                                </MyAlert>
                            )}
                        </Col>
                    </Row>
                    <Row className="mb-3" style={{ display: this.state.hasFromLocationLoaded ? 'block' : 'none' }}>
                        <Col xs={12}>
                            <button type="button" style={{ display: this.state.hasFromLocationLoaded ? 'block' : 'none' }} className="btn btn-success col-12 mb-2" onClick={() => { this.clearAll("Please scan again"); }}>Back</button>
                        </Col>
                    </Row>
                    <Row className="mb-3" style={{ display: this.state.hasFromLocationLoaded ? 'block' : 'none' }}>
                        <Col xs={12}>
                            <button type="button" style={{ display: this.state.hasFromLocationLoaded ? 'block' : 'none' }} className="btn btn-success col-12 mb-2" onClick={() => { this.setState({ displayAdditionalInfo: true }); }}>Additional Info</button>
                        </Col>
                    </Row>
                    <Row className="mb-3" style={{ display: this.state.hasFromLocationLoaded ? 'block' : 'none' }} >
                        <Col>
                            <label>Transfer To :</label>
                            <input ref="transferToLocationInput" className="form-control" placeholder="Enter Location Barcode" disabled={this.state.isTransferDisabled}
                                value={this.state.toLocationBarcode}
                                onChange={(e) => {
                                    this.setState({ toLocationBarcode: e.target.value });
                                }}
                                readOnly={this.state.sending} onKeyPress={handleToLocationKeypress}></input>
                        </Col>
                    </Row>
                    <Row className="mb-3" style={{ display: this.state.hasFromLocationLoaded ? 'block' : 'none' }}>
                        <Col>
                            <button type="button" disabled={this.state.isTransferDisabled} className="btn btn-success col-12 mb-2" onClick={() => { this.transferInventories(); }}>Transfer Stock</button>
                        </Col>
                    </Row>
                    <Row className="mb-3">
                        <Col>
                            <label>Transfer From :</label>
                            <input ref="transferFromLocationInput" className="form-control" placeholder="Enter Location Barcode"
                                disabled={this.state.hasFromLocationLoaded}
                                value={this.state.fromLocationBarcode}
                                onChange={(e) => {
                                    this.setState({ fromLocationBarcode: e.target.value, toLocation: "", inventories: [], fromLocationStatus: "", isTransferDisabled: false });
                                }}
                                readOnly={this.state.sending} onKeyPress={handleFromLocationKeypress} ></input>
                        </Col>
                        <Col style={{ display: this.state.hasFromLocationLoaded ? 'block' : 'none' }}>
                            <label>Location Status : {this.state.fromLocationStatus}</label>
                        </Col>
                    </Row>
                    <Row className="mb-3" style={{ display: !this.state.hasFromLocationLoaded ? 'block' : 'none' }} >
                        <Col>
                            <button type="button" className="btn btn-success col-12 mb-2" onClick={() => { this.loadStock(); }}>Next</button>
                        </Col>
                    </Row>
                    <Row className="mb-3" style={{ display: this.state.hasFromLocationLoaded ? 'block' : 'none' }} >
                        <Col xs={12}> <h5>Inventory in Location</h5> </Col>
                    </Row>
                    <Row style={{ display: this.state.hasFromLocationLoaded ? 'block' : 'none' }} >
                        <Col>
                            <div className="tableHolder hm-50vh mb-3">
                                {inventoryContents}
                            </div>
                        </Col>
                    </Row>
                </Container>

                {displayPrompt}
                {displayAdditionalInfoPrompt}
            </div>
        );
    }
}
